import styled from 'styled-components'
import Colors from '../../../../themes/Colors'

export const PAGE_PADDING = 4
const ARROW_SIZE = 24

const FoldersSliderHolder = styled.div`
  position: relative;

  .folders-slider-viewport {
    overflow: hidden;
    margin: -${PAGE_PADDING}px;
  }

  .folders-slider-track {
    display: flex;
    transition: transform 0.35s ease;
  }

  .folders-slider-page {
    flex: 0 0 100%;
    min-width: 0;
    display: grid;
    gap: 12px;
    align-content: start;
    padding: ${PAGE_PADDING}px;
  }

  .folders-slider-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;
    width: ${ARROW_SIZE}px;
    height: ${ARROW_SIZE}px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    color: ${Colors.primary};
    background: ${Colors.snow};
    border: 1px solid #e8e8e8;
    border-radius: 50%;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
    cursor: pointer;
    transition: border-color 0.2s;

    &:hover {
      border-color: ${Colors.primary};
    }

    &.prev {
      left: -${ARROW_SIZE}px;
    }

    &.next {
      right: -${ARROW_SIZE}px;
    }
  }
`

export default FoldersSliderHolder
